import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFunctionExecuted = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18 1.5c9.113 0 16.5 7.387 16.5 16.5S27.113 34.5 18 34.5 1.5 27.113 1.5 18 8.887 1.5 18 1.5ZM9.145 11.879a.558.558 0 0 0-.351.122.502.502 0 0 0-.192.315L6.189 23.682c-.023.128-.006.233.052.314.07.082.17.122.298.122h2.255c.128 0 .246-.04.35-.122a.5.5 0 0 0 .192-.314l.822-3.882h1.801l1.172 3.846c.035.094.087.198.157.315.082.105.233.157.454.157h2.309a.487.487 0 0 0 .297-.104.424.424 0 0 0 .157-.263.486.486 0 0 0 .018-.105.293.293 0 0 0-.018-.087l-1.486-4.301a4.972 4.972 0 0 0 1.836-1.294c.524-.571.874-1.271 1.05-2.099.267-1.27.04-2.25-.683-2.937-.711-.7-1.818-1.049-3.322-1.05H9.145Zm10.782 0a.559.559 0 0 0-.35.123.532.532 0 0 0-.176.314L19 14.187a.379.379 0 0 0 .07.315c.07.082.163.122.28.122h3.112l-1.942 9.058c-.023.128 0 .233.07.314a.37.37 0 0 0 .298.122h2.308c.128 0 .24-.04.332-.122a.5.5 0 0 0 .193-.314l1.923-9.058h3.112a.49.49 0 0 0 .333-.122.57.57 0 0 0 .191-.315l.403-1.87c.023-.129 0-.233-.07-.315-.058-.082-.152-.123-.28-.123h-9.406Zm-6.586 2.43c.57 0 .955.14 1.153.42.21.28.268.648.175 1.102-.105.466-.32.833-.646 1.1-.327.269-.764.403-1.312.403h-2.028l.647-3.024h2.01Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFunctionExecuted);
export { ForwardRef as ReactComponent };
